import request from "../request.js";
// 证券公司列表
export function csrc_zqgs() {
  // console.log(data);
  return request({
    url: "/api/v1/csrc/zqgs",
    headers: { "content-type": "application/json" },
    method: "get",
  });
}
// 业务领域列表
export function csrc_ywly() {
  // console.log(data);
  return request({
    url: "/api/v1/csrc/ywly",
    headers: { "content-type": "application/json" },
    method: "get",
  });
}

// 发布机关列表
export function csrc_fwjg() {
  // console.log(data);
  return request({
    url: "/api/v1/csrc/fwjg",
    headers: { "content-type": "application/json" },
    method: "get",
  });
}

// 查询结果汇总
export function csrc_search_stats(data) {
  return request({
    url: "/api/v1/csrc/search_stats",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// 查询结果列表
export function csrc_search(data) {
  return request({
    url: "/api/v1/csrc/search",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// 查询详情
// export function csrc_info(id) {
//   // console.log(data);
//   return request({
//     url: "/api/v1/csrc/info/"+id.toString(),
//     headers: { "content-type": "application/json" },
//     method: "get",
//   });
// }
// 查询详情
export function csrc_info(data) {
  return request({
    url: "/api/v1/csrc/info",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}
// 查询关键词联想
export async function csrc_search_suggestions(data) {
  return request({
    url: "/api/v1/csrc/search_suggestions",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// 最新更新日期查询
export function csrc_latest_data_dt() {
  // console.log(data);
  return request({
    url: "/api/v1/csrc/latest_data_dt",
    headers: { "content-type": "application/json" },
    method: "get",
  });
}

// 修改密码
export async function csrc_reset_password(data) {
  return request({
    url: "/api/v1/sys_user/me/password",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// 默认查询
export function default_search() {
  // console.log(data);
  return request({
    url: "/api/v1/csrc/default_search",
    headers: { "content-type": "application/json" },
    method: "post",
    data: "",
  });
}
